import { LocalStorageKeys } from '../constants'

class _LocalStorageService {
    setAccepted(newAccepted) {
        localStorage.setItem(LocalStorageKeys.ACCEPTED, JSON.stringify(newAccepted))
    }

    setRejected(newRejected) {
        localStorage.setItem(LocalStorageKeys.REJECTED, JSON.stringify(newRejected))
    }

    setAnonFeedbackId(newId) {
        localStorage.setItem(LocalStorageKeys.ANON_FEEDBACK_ID, JSON.stringify(newId))
    }

    getAccepted() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.ACCEPTED))
    }

    getRejected() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.REJECTED))
    }

    getAnonFeedbackId() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.ANON_FEEDBACK_ID))
    }

    getSiderCollapsed() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.SIDER_COLLAPSED))
    }

    getGroupByTypeForQuestionPage() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.GROUP_BY_TYPE_FOR_QUESTION_PAGE))
    }

    setGroupByTypeForQuestionPage(groupByType) {
        localStorage.setItem(LocalStorageKeys.GROUP_BY_TYPE_FOR_QUESTION_PAGE, JSON.stringify(groupByType))
    }

    getLastVisitedAssignmentVersion(token) {
        const lastVisitedAssignmentVersion = JSON.parse(
            localStorage.getItem(LocalStorageKeys.LAST_VISITED_ASSIGNMENT_VERSIONS),
        )
        if (lastVisitedAssignmentVersion) return lastVisitedAssignmentVersion[token]
    }

    updateLastVisitedAssignmentVersion(token, versionId) {
        let lastVisitedAssignmentVersions = JSON.parse(
            localStorage.getItem(LocalStorageKeys.LAST_VISITED_ASSIGNMENT_VERSIONS),
        )
        if (lastVisitedAssignmentVersions) {
            lastVisitedAssignmentVersions[token] = versionId
        } else {
            lastVisitedAssignmentVersions = {
                [token]: versionId,
            }
        }

        localStorage.setItem(
            LocalStorageKeys.LAST_VISITED_ASSIGNMENT_VERSIONS,
            JSON.stringify(lastVisitedAssignmentVersions),
        )
    }

    getDraftInstantFeedbackSolution(token) {
        const draftInstantFeedbackSolution = JSON.parse(
            localStorage.getItem(LocalStorageKeys.DRAFT_INSTANT_FEEDBACK_SOLUTIONS),
        )
        if (draftInstantFeedbackSolution) return draftInstantFeedbackSolution[token]
    }

    updateDraftInstantFeedbackSolution(token, solution) {
        let draftInstantFeedbackSolutions = JSON.parse(
            localStorage.getItem(LocalStorageKeys.DRAFT_INSTANT_FEEDBACK_SOLUTIONS),
        )
        if (draftInstantFeedbackSolutions) {
            draftInstantFeedbackSolutions[token] = solution
        } else {
            draftInstantFeedbackSolutions = {
                [token]: solution,
            }
        }

        localStorage.setItem(
            LocalStorageKeys.DRAFT_INSTANT_FEEDBACK_SOLUTIONS,
            JSON.stringify(draftInstantFeedbackSolutions),
        )
    }
}

const LocalStorageService = new _LocalStorageService()
export default LocalStorageService
